import { Container, Text, Group, Stack, Box, SimpleGrid } from '@mantine/core';
import { IconRobot } from '@tabler/icons-react';
import { Link } from 'react-router-dom'; // 1. Import Link
import { FOOTER_LINKS } from '../../data/navigation';
import { HOME_CONTENT } from '../../data/homeContent';

/**
 * Footer component displays branding, navigation links, and legal information at the bottom of the application.
 */
export default function Footer() {
    return (
        <Box
            component="footer"
            style={{
                backgroundColor: '#050505',
                borderTop: '1px solid rgba(255, 255, 255, 0.05)',
                position: 'relative',
                zIndex: 1
            }}
        >
            <Container size="lg" py={60}>
                <SimpleGrid cols={{ base: 1, sm: 2, md: 4 }} spacing={50}>
                    <Stack gap="lg" align="flex-start">
                        <Link to="/" style={{ textDecoration: 'none' }}>
                            <Group gap={8} style={{ cursor: 'pointer' }}>
                                <IconRobot size={26} color="#228be6" style={{ filter: 'drop-shadow(0 0 8px rgba(34, 139, 230, 0.4))' }} />
                                <Text fw={900} size="lg" c="white" style={{ letterSpacing: '-0.5px' }}>
                                    Kahoot <span style={{ color: '#228be6' }}>Bot</span>
                                </Text>
                            </Group>
                        </Link>

                        <Text size="sm" c="dimmed" lh={1.6} maw={300}>
                            {HOME_CONTENT.footer.description}
                        </Text>
                    </Stack>

                    {FOOTER_LINKS.map((group) => (
                        <Stack key={group.title} gap="md">
                            <Text size="sm" fw={700} c="white" tt="uppercase" ls={1} style={{ opacity: 0.8 }}>
                                {group.title}
                            </Text>
                            <Stack gap="xs">
                                {group.links.map((link) => (
                                    <Text
                                        key={link.label}
                                        component={Link}
                                        to={link.link}
                                        size="sm"
                                        c="dimmed"
                                        style={{ textDecoration: 'none', transition: 'color 0.2s, transform 0.2s', display: 'inline-block' }}
                                        onMouseEnter={(e) => { e.currentTarget.style.color = '#228be6'; e.currentTarget.style.transform = 'translateX(4px)'; }}
                                        onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--mantine-color-dimmed)'; e.currentTarget.style.transform = 'translateX(0)'; }}
                                    >
                                        {link.label}
                                    </Text>
                                ))}
                            </Stack>
                        </Stack>
                    ))}
                </SimpleGrid>

                <Box mt={60} pt="md" style={{ borderTop: '1px solid rgba(255, 255, 255, 0.05)', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '1rem' }}>
                    <Text c="dimmed" size="xs">© {new Date().getFullYear()} Kahoot-Bot.net. All rights reserved.</Text>
                    <Group gap="xl">
                        <Text component={Link} to="/privacy" c="dimmed" size="xs" style={{ textDecoration: 'none' }}>Privacy</Text>
                        <Text component={Link} to="/terms" c="dimmed" size="xs" style={{ textDecoration: 'none' }}>Terms</Text>
                        <Group gap={4}>
                            <div style={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: '#09c372', boxShadow: '0 0 8px #09c372' }} />
                            <Text size="xs" c="dimmed" fw={500}>All Systems Operational</Text>
                        </Group>
                    </Group>
                </Box>
      </Container>
    </Box>
  );
}